
export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-amber-600 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div>
            <img
              src="https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/e62ab94b377030bab304226dbded8c13.jpeg"
              alt="The Monthly Millionaire Project"
              className="h-16 w-auto mb-6"
            />
            <p className="text-amber-50 mb-6 leading-relaxed text-sm">
              A structured health business system designed to help everyday people start earning and build sustainable wellness teams.
            </p>
            <div>
              <p className="font-semibold mb-2 text-sm">Banking Partners:</p>
              <p className="text-amber-50 text-sm">Fidelity Bank • Access Bank</p>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('how-it-works')}
                  className="text-amber-50 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  How It Works
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('why-project')}
                  className="text-amber-50 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Why This Project
                </button>
              </li>
              <li>
                <button
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  className="text-amber-50 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Four Pillars
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('application-form')}
                  className="text-amber-50 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Apply Now
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-6">Contact</h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-phone-line text-base"></i>
                </div>
                <a href="tel:+2349137897299" className="text-amber-50 hover:text-white transition-colors ml-3 text-sm cursor-pointer">
                  +234 913 789 7299
                </a>
              </li>
              <li className="flex items-start">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-whatsapp-line text-base"></i>
                </div>
                <a
                  href="https://wa.me/2349137897299"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-amber-50 hover:text-white transition-colors ml-3 text-sm cursor-pointer"
                >
                  Chat on WhatsApp
                </a>
              </li>
              <li className="flex items-start">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-mail-line text-base"></i>
                </div>
                <a
                  href="mailto:themonthlymillionairesproject@gmail.com"
                  className="text-amber-50 hover:text-white transition-colors ml-3 text-sm cursor-pointer break-all"
                >
                  themonthlymillionairesproject@gmail.com
                </a>
              </li>
              <li className="flex items-start">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-base"></i>
                </div>
                <p className="text-amber-50 ml-3 text-sm">
                  #2 Allen Avenue, Gabriel Akinmade Taylor Plaza, Near Toyin Roundabout, Ikeja. 3rd Floor, Winning Life Center
                </p>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-amber-500 pt-8">
          <p className="text-amber-50 text-sm text-center">
            © 2026 The Monthly Millionaire Project. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
